// @flow
import React from 'react';
import ClientInfo from '../context/clientInfo';
import ClientPage from '../context/clientPage';
import ClientConfig from '../context/clientConfig';
import i18n from '../../i18n';

import fetchV3RecaptchaToken from './fetchV3RecaptchaToken';

const SubmitBtn = () => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const {
        buttonClassNames, buttonText, showEnhancedResults, clearCardNumberOnError, clearCardNumberOnSuccess,
        formatCardNum, buttonAriaLabel, customNS
      } = clientConfig;
      return (
        <ClientInfo.Consumer>
          {({ clientInfo }) => {
            const {
              host, language, showCaptcha,
            } = clientInfo;
            return (
              <ClientPage.Consumer>
                {({ pageData, actions, formState }) => {
                  const { cardNo, pin } = pageData;
                  const { handleSubmit } = actions;
                  const { isEnabled } = formState;
                  return (
                    <button
                      className={buttonClassNames}
                      type='submit'
                      disabled={!isEnabled}
                      aria-label={i18n.t(buttonAriaLabel, {ns: customNS})}
                      onClick={async e => {
                        e.preventDefault();
                        let token = null;
                        if (showCaptcha === 3) {
                          token = await fetchV3RecaptchaToken();
                        }

                        const data = {
                          host,
                          language,
                          pin,
                          cardNo,
                          callEnhanced: showEnhancedResults,
                          showCaptcha,
                          clearCardNumberOnError,
                          clearCardNumberOnSuccess,
                          formatCardNum,
                          token,
                        };
                        return handleSubmit(data);
                      }}
                    >
                      {i18n.t(buttonText, {ns: customNS})}
                    </button>
                  );
                }}
              </ClientPage.Consumer>
            );
          }}
        </ClientInfo.Consumer>
      );
    }}
  </ClientConfig.Consumer>
);

export default SubmitBtn;
